import { render, staticRenderFns } from "./VisualizarAcompanhamentoDeTurmas.vue?vue&type=template&id=4f6fe130"
import script from "./VisualizarAcompanhamentoDeTurmas.vue?vue&type=script&lang=js"
export * from "./VisualizarAcompanhamentoDeTurmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports